import { Action } from '@ngrx/store';

export enum PackagingManagerActionTypes {
  LoadUnassigned = '[PackagingManager] Load unassigned',
  LoadUnassignedSuccess = '[PackagingManager] Load unassigned success',
  LoadUnassignedFail = '[PackagingManager] Load unassigned fail',
  LoadAssigned = '[PackagingManager] Load assigned',
  LoadAssignedSuccess = '[PackagingManager] Load assigned success',
  LoadAssignedFail = '[PackagingManager] Load assigned fail',
  LoadPackagingUsers = '[PackagingManager] Load packaging users',
  LoadPackagingUsersSuccess = '[PackagingManager] Load packaging users success',
  LoadPackagingUsersFail = '[PackagingManager] Load packaging users fail',
  AssignUser = '[PackagingManager] Assign user',
  AssignUserSuccess = '[PackagingManager] Assign user success',
  AssignUserFail = '[PackagingManager] Assign user fail',
  UnassignUser = '[PackagingManager] Unassign user',
  UnassignUserSuccess = '[PackagingManager] Unassign user success',
  UnassignUserFail = '[PackagingManager] Unassign user fail',
  AddAllUnassigned = '[PackagingManager] Add all unassigned',
  AddAllAssigned = '[PackagingManager] Add all assigned',
  AddAllPackagingUsers = '[PackagingManager] Add all packaging users'
}

export class LoadUnassigned implements Action {
  readonly type = PackagingManagerActionTypes.LoadUnassigned;
  constructor(public filters?: any) {}
}

export class LoadUnassignedSuccess implements Action {
  readonly type = PackagingManagerActionTypes.LoadUnassignedSuccess;
  constructor(public packagingManagers: any[]) {}
}

export class LoadUnassignedFail implements Action {
  readonly type = PackagingManagerActionTypes.LoadUnassignedFail;
  constructor(public error: any) {}
}

export class LoadAssigned implements Action {
  readonly type = PackagingManagerActionTypes.LoadAssigned;
  constructor(public filters?: any) {}
}

export class LoadAssignedSuccess implements Action {
  readonly type = PackagingManagerActionTypes.LoadAssignedSuccess;
  constructor(public packagingManagers: any[]) {}
}

export class LoadAssignedFail implements Action {
  readonly type = PackagingManagerActionTypes.LoadAssignedFail;
  constructor(public error: any) {}
}

export class LoadPackagingUsers implements Action {
  readonly type = PackagingManagerActionTypes.LoadPackagingUsers;
  constructor() {}
}

export class LoadPackagingUsersSuccess implements Action {
  readonly type = PackagingManagerActionTypes.LoadPackagingUsersSuccess;
  constructor(public packagingUsers: any[]) {}
}

export class LoadPackagingUsersFail implements Action {
  readonly type = PackagingManagerActionTypes.LoadPackagingUsersFail;
  constructor(public error: any) {}
}

export class AssignUser implements Action {
  readonly type = PackagingManagerActionTypes.AssignUser;
  constructor(public packagingId: number, public userId: number) {}
}

export class AssignUserSuccess implements Action {
  readonly type = PackagingManagerActionTypes.AssignUserSuccess;
  constructor(public packaging: any) {}
}

export class AssignUserFail implements Action {
  readonly type = PackagingManagerActionTypes.AssignUserFail;
  constructor(public error: any) {}
}

export class UnassignUser implements Action {
  readonly type = PackagingManagerActionTypes.UnassignUser;
  constructor(public packagingId: number, public userId: number) {}
}

export class UnassignUserSuccess implements Action {
  readonly type = PackagingManagerActionTypes.UnassignUserSuccess;
  constructor(public packagingId: number, public userId: number) {}
}

export class UnassignUserFail implements Action {
  readonly type = PackagingManagerActionTypes.UnassignUserFail;
  constructor(public error: any) {}
}

export class AddAllUnassigned implements Action {
  readonly type = PackagingManagerActionTypes.AddAllUnassigned;
  constructor(public packagingManagers: any[]) {}
}

export class AddAllAssigned implements Action {
  readonly type = PackagingManagerActionTypes.AddAllAssigned;
  constructor(public packagingManagers: any[]) {}
}

export class AddAllPackagingUsers implements Action {
  readonly type = PackagingManagerActionTypes.AddAllPackagingUsers;
  constructor(public packagingUsers: any[]) {}
}

export type PackagingManagerActionsUnion =
  | LoadUnassigned
  | LoadUnassignedSuccess
  | LoadUnassignedFail
  | LoadAssigned
  | LoadAssignedSuccess
  | LoadAssignedFail
  | LoadPackagingUsers
  | LoadPackagingUsersSuccess
  | LoadPackagingUsersFail
  | AssignUser
  | AssignUserSuccess
  | AssignUserFail
  | UnassignUser
  | UnassignUserSuccess
  | UnassignUserFail
  | AddAllUnassigned
  | AddAllAssigned
  | AddAllPackagingUsers;
